import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'

import { $isCreatorProcessCompleted } from '@/models/creators.ts'
import { creatorService } from '@/modules/creators/service/creator-service.ts'
import { handleError } from '@/utils/error'

export function useCreatorStates() {
  const isCreatorProcessCompleted = useUnit($isCreatorProcessCompleted)
  const {
    data: creatorStates,
    isLoading,
    isIdle,
  } = useQuery(
    'creator-states',
    async () => {
      return await creatorService.getCreatorStates()
    },
    {
      enabled: isCreatorProcessCompleted,
      refetchInterval: 5000,
      onError: (error) => handleError(error, 'Failed to get creator states'),
    },
  )

  return { creatorStates, creatorStatesLoading: isLoading || isIdle }
}
